import React from "react";
import { Col, Tab as BootstrapTab } from "react-bootstrap";
import classNames from "classnames";
import PropTypes from "prop-types";

import "./styles.scss";

const Content = ({ children, className = "", ...rest }) => (
  <Col {...rest}>
    <BootstrapTab.Content
      className={classNames("mydpd-tab-content", className)}
    >
      {children}
    </BootstrapTab.Content>
  </Col>
);

Content.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

export default Content;
